"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitialLoadMiddleware = void 0;
const ac_1 = require("@app/ac");
const const_1 = require("@app/const");
const store_1 = __importStar(require("@app/store"));
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const get_shift_default_details_1 = require("../../get-shift-default-details");
const shift_context_1 = require("../../shift-context");
// Creating or editing shift
const loadLiveState = async (initialData, props) => {
    if ((0, util_1.isUndefined)(initialData?.shiftId)) {
        return { formData: props.getShiftDefaultDetails(initialData?.data) };
    }
    const includeCandidates = false;
    const includeOffer = false;
    const existingShiftData = await props.dispatch((0, ac_1.loadShiftDetail)(initialData?.shiftId, includeCandidates, includeOffer));
    const formData = props.getShiftDefaultDetails(existingShiftData);
    return { formData, existingShiftData };
};
// either
// Editing existing template, load data from workspace shift templates
// or
// Creating template from existing shift - no need to load any data just duplicate it.
const loadShiftTemplateState = async (initialData, props) => {
    const shiftTemplateId = initialData?.shiftTemplateId;
    if ((0, util_1.isDefined)(shiftTemplateId)) {
        const templates = props.workspace?.shiftTemplates?.filter(util_1.isValue) ?? [];
        const template = templates.find((tmp) => tmp.id === initialData?.shiftTemplateId);
        const formData = props.getShiftDefaultDetails((0, maybe_unwrap_1.unwrapMaybe)(template?.shift));
        return { formData };
    }
    const formData = props.getShiftDefaultDetails(initialData?.data);
    return { formData };
};
const loadTemplateState = async (initialData, props) => {
    if ((0, util_1.isUndefined)(initialData?.shiftId)) {
        const formData = props.getShiftDefaultDetails({});
        return { formData };
    }
    const state = store_1.default.getState();
    const templates = state.templates;
    const { start, duration, special, ...shiftData } = util_1.propsUtil.getShift({
        templateId: initialData?.templateId,
        shiftHash: initialData?.shiftId,
        templates,
    });
    const period = {
        start: (0, moment_1.default)().set({ hours: 0, minutes: 0, second: 0 }).add(start, 'minutes'),
        end: (0, moment_1.default)()
            .set({ hours: 0, minutes: 0, second: 0 })
            .add(start + duration, 'minutes'),
    };
    const formData = props.getShiftDefaultDetails({
        period,
        ...shiftData,
    });
    return { formData };
};
const loadCycleState = async (initialData, props) => {
    const loadDetail = () => {
        if ((0, util_1.isDefined)(initialData?.shiftId)) {
            const existingDetail = store_1.default
                .getState()
                .cycleDetail.data.find((detail) => detail.data.id === initialData?.shiftId)?.data;
            return existingDetail;
        }
        const lastDetail = store_1.default.getState().cycleDetail.data?.at(-1)?.data;
        return lastDetail;
    };
    const detail = loadDetail();
    if (!(0, util_1.isValue)(detail)) {
        return { formData: props.getShiftDefaultDetails({}) };
    }
    const columnOffset = 24 * 60 * (initialData?.cycle?.colId ?? 0);
    const start = detail.start - columnOffset;
    const duration = detail.duration ?? 0;
    const shiftDataPeriod = {
        start: (0, moment_1.default)().set({ hours: 0, minutes: 0, second: 0 }).add(start, 'minutes'),
        end: (0, moment_1.default)()
            .set({ hours: 0, minutes: 0, second: 0 })
            .add(start + duration, 'minutes'),
    };
    const mappedDetail = {
        ...detail,
        period: shiftDataPeriod,
    };
    const formData = props.getShiftDefaultDetails(mappedDetail);
    return { formData };
};
const useComputeDisabledEditation = (initialData) => {
    const workspace = (0, useWorkspace_1.useWorkspace)();
    return (details) => {
        if (initialData?.type === 'live') {
            if (details.period?.start &&
                util_1.miscUtil.isMyCalendarLocked(details.period.start, workspace))
                return 'disabled-due-to-locked-period';
        }
        // disable editation
        if (initialData?.type === 'shiftTemplate' &&
            !util_1.permissionsUtil.canWrite(const_1.PERMISSIONS.WORKSPACE.SHIFTTEMPLATES)) {
            return 'disabled-due-to-missing-template-write-permission';
        }
    };
};
const useInitialLoadMiddleware = ({ reset, initialData, syncShiftSections, loadDummyShift, setDisabledEditation, setInitialLoad, setExistingShiftData, }) => {
    const dispatch = (0, store_1.useRootDispatch)();
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const getShiftDefaultDetails = (0, get_shift_default_details_1.useGetShiftDefaultDetails)();
    const computeDisabledEditation = useComputeDisabledEditation(initialData);
    react_1.default.useEffect(() => {
        void dispatch((0, ac_1.isLoading)(shift_context_1.LOADING_SHIFT_ACTION, false));
        const action = async () => {
            const loadMiddlewareStateProps = {
                workspace,
                getShiftDefaultDetails,
                dispatch,
            };
            if (initialData?.type === 'template') {
                const { formData } = await loadTemplateState(initialData, loadMiddlewareStateProps);
                reset(formData, {
                    keepValues: false,
                    keepDefaultValues: false,
                    keepDirtyValues: false,
                });
                const disabledEditation = computeDisabledEditation(formData);
                setDisabledEditation(disabledEditation);
                if (!(0, util_1.isDefined)(disabledEditation)) {
                    await loadDummyShift(formData);
                }
                syncShiftSections(formData);
                await dispatch((0, ac_1.isLoading)(shift_context_1.LOADING_SHIFT_ACTION, true));
                setInitialLoad(false);
                return;
            }
            if (initialData?.type === 'shiftTemplate') {
                const { formData } = await loadShiftTemplateState(initialData, loadMiddlewareStateProps);
                reset(formData, {
                    keepValues: false,
                    keepDefaultValues: false,
                    keepDirtyValues: false,
                });
                const disabledEditation = computeDisabledEditation(formData);
                setDisabledEditation(disabledEditation);
                if (!(0, util_1.isDefined)(disabledEditation)) {
                    await loadDummyShift(formData);
                }
                syncShiftSections(formData);
                await dispatch((0, ac_1.isLoading)(shift_context_1.LOADING_SHIFT_ACTION, true));
                setInitialLoad(false);
                return;
            }
            if (initialData?.type === 'live') {
                const { formData, existingShiftData } = await loadLiveState(initialData, loadMiddlewareStateProps);
                if (existingShiftData) {
                    setExistingShiftData(existingShiftData);
                }
                reset(formData, {
                    keepValues: false,
                    keepDefaultValues: false,
                    keepDirtyValues: false,
                });
                const disabledEditation = computeDisabledEditation(formData);
                setDisabledEditation(disabledEditation);
                if (!(0, util_1.isDefined)(disabledEditation) && !existingShiftData?.transfer) {
                    await loadDummyShift(formData);
                }
                syncShiftSections(formData);
                await dispatch((0, ac_1.isLoading)(shift_context_1.LOADING_SHIFT_ACTION, true));
                setInitialLoad(false);
                return;
            }
            if (initialData?.type === 'cycle') {
                const { formData } = await loadCycleState(initialData, loadMiddlewareStateProps);
                reset(formData, {
                    keepValues: false,
                    keepDefaultValues: false,
                    keepDirtyValues: false,
                });
                const disabledEditation = computeDisabledEditation(formData);
                setDisabledEditation(disabledEditation);
                if (!(0, util_1.isDefined)(disabledEditation)) {
                    await loadDummyShift(formData);
                }
                syncShiftSections(formData);
                await dispatch((0, ac_1.isLoading)(shift_context_1.LOADING_SHIFT_ACTION, true));
                setInitialLoad(false);
            }
        };
        void action();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
exports.useInitialLoadMiddleware = useInitialLoadMiddleware;
